import React from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress } from "@mui/material";

function Loader({ fullscreen = false, size = 48 }) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="row"
      gap={2}
      sx={{
        width: "100%",
        py: 4,
        ...(fullscreen && { minHeight: "50vh" }),
      }}
    >
      <CircularProgress size={size} color="info" thickness={4} />
    </Box>
  );
}

Loader.propTypes = {
  fullscreen: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Loader;
